import axios from "axios";
import * as ErrorMessage from "../../../constants/errorMessages";
import {
  // disableDeviceSkillsetUrl,
  // getSubscription,
  getBaseUrl,
} from "Utils/getBaseUrl";

export const DisableDeviceSkillset = (token, skillDetails) => {
  const id = skillDetails.id; //todo: get this from skillDetails
  let url = getBaseUrl();
  if (url === "http://localhost:3001") {
    url = "https://qa.fsekeygen.zeiss.com";
  }
  // const getDisableSkillUrl = disableDeviceSkillsetUrl() + "/" + id + "/Disable";
  // const esbSubscriptionKey = getSubscription();
  const getDisableSkillUrl = `${url}/fsekeygenservice/api/v1/Skill/${id}/Disable`;
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": `application/json`,
      "Access-Control-Allow-Origin": "*",
      // "EsbApi-Subscription-Key": esbSubscriptionKey,
    },
  };

  return axios
    .create(config)
    .put(`${getDisableSkillUrl}`, skillDetails)
    .then((res) => {
      if (res.status === 200) {
        if (res.data) {
          return {
            status: true,
            statusCode: 200,
            message: "Skillset Disabled successfully",
          };
        } else {
          return {
            status: false,
            statusCode: 200,
            message: "Unable to Disable Skillset",
          };
        }
      } else if (res.status === 401) {
        return {
          status: false,
          statusCode: 401,
          message: ErrorMessage.SESSION_TIMEOUT_ERROR,
        };
      } else if (res.status === 400) {
        return {
          status: false,
          statusCode: 400,
          message: res.error.message,
        };
      } else {
        return {
          status: false,
          statusCode: 400,
          message: ErrorMessage.BAD_REQUEST,
        };
      }
    })
    .catch((error) => {
      let status = error;
      if (error.response) {
        status = error.response.status;
        if (status === 401) {
          return {
            status: false,
            statusCode: 401,
            message: ErrorMessage.SESSION_TIMEOUT_ERROR,
          };
        } else {
          return {
            status: false,
            statusCode: status,
            message: error.response.data.error.message,
          };
        }
      } else if (error.request) {
        return {
          status: false,
          statusCode: 401,
          message: ErrorMessage.NETWORK_ERROR,
        };
      } else {
        return {
          status: false,
          statusCode: 401,
          message: ErrorMessage.NETWORK_ERROR,
        };
      }
    });
};
